import { IReviewsFilter } from './interfaces';

export const initialState: IReviewsFilter = {
  reviewsFilter: {},
};
